import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import scale from "../helper/scaling";

const Wrapper = styled.div`
  width: 1040px;
  margin: 45px calc(50% - 520px) 25px calc(50% - 520px);
  float: left;
  @media (max-width: 1100px) {
    width: calc(100% - 50px);
    margin: 35px 25px 25px 25px;
  }
  @media (max-width: 700px) {
    width: calc(100% - 46px);
    margin: 30px 23px 23px 23px;
  }
`;
const Title = styled.div`
  width: 100%;

  font-family: Lato;
  font-size: 28px;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: 58px;
  letter-spacing: 0.4px;
  color: #3949ab;

  margin-bottom: 40px;

  float: left;

  @media (max-width: 1100px) {
    margin-bottom: 30px;
    font-size: 25px;
  }
  @media (max-width: 700px) {
    margin-bottom: 20px;
    font-size: 22px;
  }
`;

const Items = styled.div`
  width: 100%;
  float: left;
`;

class Calendar extends Component {
  render() {
    let data = [];
    if (this.props.calendar) {
      for (var i in this.props.calendar) {
        data.push(this.props.calendar[i]);
      }
    }
    return (
      <Wrapper>
        <Title>Veilingagenda</Title>
        <Items>{data.map(item => <Event key={item.id} content={item} />)}</Items>
      </Wrapper>
    );
  }
}

const mapStateToProps = state => {
  return {
    calendar: state.calendar.data
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onTodoClick: id => {
      dispatch({ type: "NONE" });
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Calendar);

const Item = styled.div`
  width: 100%;
  margin: 10px 0;

  border: 0px solid white;
  border-radius: 5px;
  background-color: #ffffff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);

  overflow: hidden;

  @media (max-width: 1100px) {
    margin: ${scale(1100, 767, 10, 8, "vw")} 0;
  }

  @media (max-width: 700px) {
    margin: 7px 0;
  }
`;
const Upper = styled.div`
  width: 100%;
  height: 109px;
  position: relative;

  cursor: pointer;

  @media (max-width: 700px) {
    height: 152px;
  }
`;
const ImageContainer = styled.div`
  border-right: solid 1px #e5e5e5;
  height: 100%;
  width: 113px;
  float: left;
  @media (max-width: 1100px) {
    height: 100%;
    width: 110px;
  }
  @media (max-width: 700px) {
    width: 86px;
  }
`;
const Image = styled.div`
  width: calc(100% - 8px);
  height: calc(100% - 6px);

  margin: 3px 4px 3px 4px;
  border-radius: 5px;

  overflow: hidden;

  float: left;

  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  @media (max-width: 700px) {
    width: calc(100% - 6px);
    height: calc(100% - 72px);
    margin: 43px 3px 29px 3px;
  }
  @media (max-width: 700px) {
    height: calc(100% - 4px);
    margin: 2px 3px 2px 3px;
  }
`;
const UpperText = styled.div`
  margin: 16px 114px 11px 32px;
  float: left;
  height: calc(100% - 27px);
  width: calc(100% - 260px);
  @media (max-width: 1100px) {
    margin: 12px 88px 6px 9px;
    float: left;
    height: calc(100% - 18px);
    width: calc(100% - 208px);
  }
  @media (max-width: 700px) {
    margin: 14px 6px 8px 6px;
    width: calc(100% - 100px);
    height: calc(100% - 22px);
  }
`;
const UpperMonth = styled.div`
  height: 23px;
  font-family: Lato;
  font-size: 19px;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: 23px;
  letter-spacing: 1.3px;
  color: #000000;

  text-transform: uppercase;

  @media (max-width: 1100px) {
    height: 18px;
    font-size: 15px;
    line-height: 18px;
    letter-spacing: 1.1px;
  }

  @media (max-width: 700px) {
    height: 17px;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 1px;
  }
`;
const UpperTitle = styled.div`
  height: 34px;
  font-family: Lato;
  font-size: 28px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 2px;
  color: #3949ab;

  text-transform: uppercase;
  margin-bottom: 5px;

  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  @media (max-width: 1100px) {
    height: 29px;
    font-size: 24px;
    letter-spacing: ${scale(1100, 700, 2, 0, "vw")};
    margin: 1px 0 7px 0;
  }
  @media (max-width: 700px) {
    height: 34px;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 1px;
    margin: 5px 0 9px 0;

    white-space: normal;
  }
`;
const UpperDetailsWrapper = styled.div`
  padding-right: 13px;
  :last-of-type {
    padding-right: 0;
  }
  float: left;
  @media (max-width: 1100px) {
    width: 100%;
    padding-right: 0;
  }
  @media (max-width: 700px) {
    height: 30px;
    padding-bottom: 5px;
    :last-of-type {
      padding-bottom: 0;
    }
  }
`;
const UpperDetails = styled.div`
  height: 20px;
  font-family: Lato;
  font-size: 13px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.54;
  letter-spacing: 0.9px;

  text-transform: uppercase;

  @media (max-width: 1100px) {
    height: 17px;
    font-size: 11px;
    line-height: 17px;
    letter-spacing: 0.7px;
  }
  @media (max-width: 700px) {
    height: 30px;
    font-size: 9px;
    line-height: 15px;
    letter-spacing: 0.2px;
  }
`;
const UpperDetailsDates = styled.div`
  font-weight: normal;
  color: #3949ab;
  display: inline;
  padding: 0 0 0 5px;
  @media (max-width: 700px) {
    width: 100%;
    display: block;
    padding: 0;
  }
`;
const UpperActions = styled.div`
  position: absolute;
  top: 40px;
  right: 36px;
  height: 29px;
  width: 29px;
  svg {
    height: 100%;
    width: 100%;
  }
  @media (max-width: 1100px) {
    right: 30px;
  }
  @media (max-width: 700px) {
    height: 16px;
    width: 16px;
    top: 15px;
    right: 19px;
  }
`;
const Lower = styled.div`
  width: 100%;
  border-top: solid ${props => (props.open ? "1" : "0")}px #e5e5e5;
  height: 119px;
  background-color: #f8f8f8;

  max-height: ${props => (props.open ? "200" : "0")}px;
  overflow: hidden;

  position: relative;

  @media (max-width: 1100px) {
    height: 90px;
  }
  @media (max-width: 700px) {
    height: 135px;
  }
`;
const LowerText = styled.div`
  margin: 25px 31px 23px 31px;
  float: left;
  max-width: 725px;
  @media (max-width: 1100px) {
    margin: 15px 21px 17px 21px;
    max-width: calc(100% - 242px);
  }
  @media (max-width: 700px) {
    margin: 10px 11px 57px 11px;
    max-width: none;
    width: calc(100% - 22px);
  }
`;
const LowerTitle = styled.div`
  height: 23px;
  font-family: Lato;
  font-size: 19px;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: 23px;
  letter-spacing: 1.3px;
  color: #000000;

  margin-bottom: 6px;

  text-transform: uppercase;

  @media (max-width: 1100px) {
    height: 18px;
    font-size: 15px;
    letter-spacing: 1.1px;
    line-height: 18px;
    margin-bottom: 8px;
  }

  @media (max-width: 700px) {
    height: 15px;
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0.8px;
    margin-bottom: 5px;
  }
`;
const LowerBody = styled.div`
  height: 42px;
  font-family: Lato;
  font-size: 15px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.4;
  letter-spacing: 1.1px;
  color: rgba(0, 0, 0, 0.6);

  @media (max-width: 1100px) {
    height: 32px;
    font-size: 11px;
    line-height: 1.45;
    letter-spacing: 0.6px;
  }

  @media (max-width: 700px) {
    height: 48px;
    font-size: 9px;
    line-height: 1.78;
    letter-spacing: 0.1px;
  }
`;
const LowerActions = styled.div`
  position: absolute;
  top: 25px;
  right: 32px;
  height: calc(100% - 51px);
  float: right;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  @media (max-width: 1100px) {
    top: 8px;
    right: 31px;
  }
  @media (max-width: 700px) {
    width: 100%;
    top: 79px;
    right: 0;
    align-items: center;
  }
`;
const LowerActionMessage = styled.div`
  height: 17px;
  font-family: Lato;
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1px;
  color: #ff5368;

  text-transform: uppercase;
  margin-bottom: 6px;

  min-height: 17px;

  @media (max-width: 1100px) {
    height: 13px;
    font-size: 11px;
    letter-spacing: 0.8px;
    margin-bottom: 7px;
  }
  @media (max-width: 700px) {
    height: 11px;
    font-size: 9px;
    letter-spacing: 0.6px;
    margin-bottom: 0px;
    line-height: 11px;
  }
`;
const LowerActionButton = styled.a`
  height: 17px;
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1px;
  text-align: center;
  color: #ffffff;
  padding: 12px 19px 16px 19px;
  border-radius: 5px;
  pointer-events: ${props => (props.active ? "default" : "none")};
  background-color: ${props => (props.active ? "#ff5368" : "#cfcfcf")};
  cursor: ${props => (props.active ? "pointer" : "default")};
  text-transform: uppercase;
  text-decoration: none;

  @media (max-width: 1100px) {
    height: 34px;
    letter-spacing: 0.8px;
    width: 105px;
    padding: 5px 15px 6px 15px;
  }
  @media (max-width: 700px) {
    height: 12px;
    font-size: 10px;
    letter-spacing: 0.7px;
    line-height: 12px;
    padding: 6px 14px 8px 14px;
    width: auto;
  }
`;

class Event extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: props.content.active || false
    };
  }

  image = () => {
    if (this.props.content.image)
      return this.props.content.image.startsWith("http")
        ? {
            backgroundImage: 'url("' + this.props.content.image + '")'
          }
        : {
            backgroundImage:
              'url("' +
              this.props.content.auctionBaseUrl +
              "/" +
              this.props.content.image +
              '")'
          };
    return {};
  };

  toggle = () => {
    this.setState({ open: !this.state.open });
  };

  readableDayMonth = date => {
    let d = new Date(date);
    return `${this.localDay(d.getDay())} ${d.getDate()} ${this.localMonth(
      d.getMonth()
    )}`;
  };

  readableMonthYear = date => {
    let d = new Date(date);
    return `${this.localMonth(d.getMonth())} ${d.getFullYear()}`;
  };

  readableDayMonthYear = date => {
    let d = new Date(date);
    return `${this.localDay(d.getDay())} ${d.getDate()} ${this.localMonth(
      d.getMonth()
    )} ${d.getFullYear()}`;
  };

  localDay = day => {
    switch (day) {
      case 1:
        return "ma";
      case 2:
        return "di";
      case 3:
        return "wo";
      case 4:
        return "do";
      case 5:
        return "vr";
      case 6:
        return "za";
      case 0:
        return "zo";
      default:
        return "dag";
    }
  };

  localMonth = month => {
    switch (month) {
      case 0:
        return "januari";
      case 1:
        return "februari";
      case 2:
        return "maart";
      case 3:
        return "april";
      case 4:
        return "mei";
      case 5:
        return "juni";
      case 6:
        return "juli";
      case 7:
        return "augustus";
      case 8:
        return "september";
      case 9:
        return "oktober";
      case 10:
        return "november";
      case 11:
        return "december";
      default:
        return "maand";
    }
  };

  viewings = () =>
    this.props.content.viewings.length > 0 ? (
      <UpperDetailsWrapper>
        Kijkdagen
        <UpperDetailsDates>
          {this.props.content.viewings
            .map(i => this.readableDayMonth(i.start))
            .join(" / ")}
        </UpperDetailsDates>
      </UpperDetailsWrapper>
    ) : (
      <UpperDetailsWrapper>
        Kijkdagen
        <UpperDetailsDates>
          {[this.props.content.start, this.props.content.end]
            .map(i => new Date(i.getTime() - 172800000))
            .map(this.readableDayMonth)
            .join(" / ")}
        </UpperDetailsDates>
      </UpperDetailsWrapper>
    );
  bidding = () => (
    <UpperDetailsWrapper>
      Online veiling
      <UpperDetailsDates>
        {[this.props.content.start, this.props.content.end]
          .map(this.readableDayMonth)
          .join(" / ")}
      </UpperDetailsDates>
    </UpperDetailsWrapper>
  );

  render() {
    let active = this.props.content.active;
    return (
      <Item>
        <Upper onClick={this.toggle}>
          <ImageContainer>
            <Image style={this.image()} />
          </ImageContainer>
          <UpperText>
            <UpperMonth>
              {this.readableMonthYear(
                this.props.content.sessions[0]
                  ? this.props.content.sessions[0].start
                  : this.props.content.start
              )}
            </UpperMonth>
            <UpperTitle>{this.props.content.title}</UpperTitle>
            <UpperDetails>
              {this.viewings()}
              {this.bidding()}
            </UpperDetails>
          </UpperText>
          <UpperActions>{this.state.open ? <Minus /> : <Plus />}</UpperActions>
        </Upper>
        <Lower open={this.state.open}>
          <LowerText>
            <LowerTitle>Inbrengen voor deze veiling</LowerTitle>
            <LowerBody>
              U kunt voor deze veiling inbrengen t/m{" "}
              <strong>
                {this.readableDayMonthYear(this.props.content.contributionEnd)}
              </strong>
              <br />Dit kan op <strong>donderdag t/m zaterdag</strong>, tussen{" "}
              <strong>10:00 en 12:00</strong> uur en tussen{" "}
              <strong>13:00 en 16:00</strong> uur.
            </LowerBody>
          </LowerText>
          <LowerActions>
            <LowerActionMessage>
              {active ? "" : "Binnenkort beschikbaar"}
            </LowerActionMessage>
            <LowerActionButton active={active} href={this.props.content.url + '/auction?auction=' + this.props.content.id }>
              Bekijk de veiling
            </LowerActionButton>
          </LowerActions>
        </Lower>
      </Item>
    );
  }
}

class Plus extends Component {
  render() {
    return (
      <svg
        width="28px"
        height="29px"
        viewBox="0 0 28 29"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          id="Page-1"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="Other-Components"
            transform="translate(-1116.000000, -6846.000000)"
            fill="#FF5368"
          >
            <polygon
              id="plus-icon"
              points="1131.14803 6846 1131.14803 6859.3869 1144 6859.3869 1144 6861.55374 1131.14803 6861.55374 1131.14803 6875 1128.82215 6875 1128.82215 6861.55374 1116 6861.55374 1116 6859.3869 1128.82215 6859.3869 1128.82215 6846"
            />
          </g>
        </g>
      </svg>
    );
  }
}

class Minus extends Component {
  render() {
    return (
      <svg
        width="28px"
        height="2px"
        viewBox="0 0 28 2"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          id="Page-1"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="Other-Components"
            transform="translate(-1116.000000, -6480.000000)"
            fill="#FF5368"
          >
            <polygon
              id="minus-icon"
              points="1144 6480 1144 6482 1116 6482 1116 6480"
            />
          </g>
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Calendar.js